export default __webpack_public_path__ + "static/media/bel.73f52aa0.svg";